import React, { useState, useContext } from 'react';
import InputMask from 'react-input-mask';
import axios from 'axios'; // Para chamadas de API
import { useNavigate } from 'react-router-dom';
import styles from './Novo_EditarCadastro.module.css';
import { config } from '../../config'; // Supondo que config contém a base URL
import { UserContext } from '../../context/UserContext'; // Importando UserContext para obter o código do condomínio
import Overlay from '../Acessorios/Overlay';
import { logAction } from '../../services/LogAction'; // Importa a função de log de auditoria

function NovoCadastro() {
    const navigate = useNavigate();
    const { codigoCondominio, nomeUsuario, emailUsuario } = useContext(UserContext);
    const [formData, setFormData] = useState({
        nomeCompleto: '',
        CPF: '',
        email: '',
        numeroCelular: '',
        bloco: '',
        unidade: ''
    });

    const [erros, setErros] = useState({});
    const [mensagem, setMensagem] = useState('');
    const [showOverlay, setShowOverlay] = useState(false); // Estado para controlar o overlay

    const handleInputChange = (field, value) => {
        setFormData({ ...formData, [field]: value });
        if (erros[field]) {
            setErros((prevErros) => ({ ...prevErros, [field]: '' }));
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const novosErros = {};

        // Validação dos campos obrigatórios
        if (!formData.nomeCompleto) {
            novosErros.nomeCompleto = "Preencher campo obrigatório: Nome Completo";
        }

        const cpfSemMascara = formData.CPF.replace(/\D/g, '');
        if (!formData.CPF || cpfSemMascara.length !== 11) {
            novosErros.CPF = "Número de CPF inválido.";
        }

        if (!formData.email) {
            novosErros.email = "Preencher campo obrigatório: E-mail";
        }

        const celularSemMascara = formData.numeroCelular.replace(/\D/g, '');
        if (!formData.numeroCelular || celularSemMascara.length !== 11) {
            novosErros.numeroCelular = "Número de celular inválido.";
        }

        if (!formData.bloco) {
            novosErros.bloco = "Preencher campo obrigatório: Bloco";
        }

        if (!formData.unidade) {
            novosErros.unidade = "Preencher campo obrigatório: Unidade";
        }

        // Se houver erros, atualize o estado e interrompa o envio
        if (Object.keys(novosErros).length > 0) {
            setErros(novosErros);
            return;
        }

        try {
            const novoCadastro = {
                nome: formData.nomeCompleto,
                cpf: cpfSemMascara,
                email: formData.email,
                telefone: celularSemMascara,
                condominio: formData.bloco,
                codigoCondominio: codigoCondominio,
                bloco: formData.bloco,
                unidade: formData.unidade,
                statusAtivo: true
            };

            // Envia o novo cadastro para o backend
            console.log('Dados enviados para o backend:', novoCadastro);
            await axios.post(`${config.apiBaseUrl}/Cliente/novo`, novoCadastro);

            // Sucesso
            setMensagem('Cadastro criado com sucesso!');
            setShowOverlay(true);

            // Enviar o log da ação
            await logAction('Criação de Cadastro', { nomeUsuario, emailUsuario, codigoCondominio }, {
                cadastro: novoCadastro
            });

            // Após 2.5 segundos, redireciona para a página de gerenciamento de cadastros
            setTimeout(() => {
                setMensagem('');
                setShowOverlay(false);
                navigate('/morador/gerenciarcadastros');
            }, 2500);
        } catch (error) {
            setMensagem('Erro ao criar cadastro: ' + error.message);
            setShowOverlay(true);
        }
    };

    const handleCancel = () => {
        navigate('/morador/gerenciarcadastros');
    };

    return (
        <div className={styles.formContainer}>
            {showOverlay && (
                <Overlay mensagem={mensagem} isErro={!!mensagem.includes("Erro")} showOverlay={showOverlay} />
            )}

            <form onSubmit={handleSubmit}>
                <div className={styles.formRow}>
                    <label>
                        <strong>Nome Completo:</strong>
                        <input
                            type="text"
                            value={formData.nomeCompleto}
                            onChange={(e) => handleInputChange('nomeCompleto', e.target.value)}
                            className={`${styles.inputField} ${erros.nomeCompleto ? styles.highlightEmpty : ''}`}
                        />
                        {erros.nomeCompleto && <p className={styles.mensagemErro}>{erros.nomeCompleto}</p>}
                    </label>
                    <label>
                        <strong>CPF:</strong>
                        <InputMask
                            mask="999.999.999-99"
                            value={formData.CPF}
                            onChange={(e) => handleInputChange('CPF', e.target.value)}
                            className={`${styles.inputField} ${erros.CPF ? styles.highlightEmpty : ''}`}
                        />
                        {erros.CPF && <p className={styles.mensagemErro}>{erros.CPF}</p>}
                    </label>
                    <label>
                        <strong>E-mail:</strong>
                        <input
                            type="email"
                            value={formData.email}
                            onChange={(e) => handleInputChange('email', e.target.value)}
                            className={`${styles.inputField} ${erros.email ? styles.highlightEmpty : ''}`}
                        />
                        {erros.email && <p className={styles.mensagemErro}>{erros.email}</p>}
                    </label>
                    <label>
                        <strong>Número do Celular:</strong>
                        <InputMask
                            mask="(99) 99999-9999"
                            value={formData.numeroCelular}
                            onChange={(e) => handleInputChange('numeroCelular', e.target.value)}
                            className={`${styles.inputField} ${erros.numeroCelular ? styles.highlightEmpty : ''}`}
                        />
                        {erros.numeroCelular && <p className={styles.mensagemErro}>{erros.numeroCelular}</p>}
                    </label>
                    <label>
                        <strong>Bloco:</strong>
                        <input
                            type="text"
                            value={formData.bloco}
                            onChange={(e) => handleInputChange('bloco', e.target.value)}
                            className={`${styles.inputField} ${erros.bloco ? styles.highlightEmpty : ''}`}
                        />
                        {erros.bloco && <p className={styles.mensagemErro}>{erros.bloco}</p>}
                        <p className={styles.instrucao}>Caso não haja bloco, preencher com: <strong>-</strong></p>
                    </label>
                    <label>
                        <strong>Unidade:</strong>
                        <input
                            type="text"
                            value={formData.unidade}
                            onChange={(e) => handleInputChange('unidade', e.target.value)}
                            className={`${styles.inputField} ${erros.unidade ? styles.highlightEmpty : ''}`}
                        />
                        {erros.unidade && <p className={styles.mensagemErro}>{erros.unidade}</p>}
                    </label>
                </div>
                <button type="submit" className={styles.submitButton}>Cadastrar</button>
                <button type="button" className={styles.cancelButton} onClick={handleCancel}>Cancelar</button>
            </form>
        </div>
    );
}

export default NovoCadastro;
